// Generated by Claude Code
import { PeriodicMaintenanceDisplayPanel } from '#components/domain/operations/periodic-maintenances/detail/periodic-maintenance-display-panel.tsx'
import { PeriodicMaintenanceEditDrawer } from '#components/domain/operations/periodic-maintenances/edit/periodic-maintenance-edit-drawer.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { readAnyGroups } from '#core/entities/auth/roles/permission-gate-helpers.ts'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_app/$companyId/periodic-maintenances/$periodicMaintenanceId')({
  component: RouteComponent,
  staticData: {
    title: 'Periodic Maintenance Detail',
  },
})

function RouteComponent() {
  return (
    <PermissionGuard permissions={readAnyGroups(PermissionService.PERIODIC_MAINTENANCES)} redirectOnNotAuthorized>
      <PeriodicMaintenanceDetailPageContent />
    </PermissionGuard>
  )
}

function PeriodicMaintenanceDetailPageContent() {
  const { companyId, periodicMaintenanceId } = Route.useParams()
  const navigate = useNavigate()
  const { t } = useTranslation('periodic-maintenances')

  const [editOpen, setEditOpen] = useState(false)
  const [reloadKey, setReloadKey] = useState(0)

  function handleBack() {
    void navigate({ to: '/$companyId/periodic-maintenances', params: { companyId } })
  }

  return (
    <div className="container-fluid d-flex flex-column h-100 py-3">
      <div className="row justify-content-center flex-grow-1">
        <div className="col-12 col-lg-10 col-xl-8 d-flex flex-column">
          <div className="mb-2">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
              onClick={handleBack}
            >
              <ArrowLeft size={14} />
              {t('shared.actions.backToList')}
            </button>
          </div>
          <div className="flex-grow-1 overflow-hidden card rounded-3 p-0">
            <PeriodicMaintenanceDisplayPanel
              scheduleId={periodicMaintenanceId}
              onClose={handleBack}
              onEdit={() => setEditOpen(true)}
              reloadKey={reloadKey}
            />
          </div>
        </div>
      </div>

      <PeriodicMaintenanceEditDrawer
        isOpen={editOpen}
        mode="edit"
        periodicMaintenanceId={periodicMaintenanceId}
        onClose={() => setEditOpen(false)}
        onUpdated={() => { setEditOpen(false); setReloadKey((k) => k + 1) }}
      />
    </div>
  )
}
